import { SettingsDialog } from "@/components/SettingsDialog/SettingsDialog";
import { OpenSettingsProvider } from "@/context/OpenSettingsContext";
import {
  normalizeOpenSettingsInput,
  type OpenSettingsInput,
  type OpenSettingsState,
} from "@/utils/settingsNavigation";
import React, { useCallback, useState } from "react";
import { useSettingsRouteSync } from "./useSettingsRouteSync";

interface LayoutSettingsShellProps {
  children: React.ReactNode;
}

export function LayoutSettingsShell({ children }: LayoutSettingsShellProps) {
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);
  const [settingsInitialNavigation, setSettingsInitialNavigation] =
    useState<OpenSettingsState>({});

  const openSettings = useCallback((input?: OpenSettingsInput) => {
    setSettingsInitialNavigation(normalizeOpenSettingsInput(input));
    setSettingsDialogOpen(true);
  }, []);

  useSettingsRouteSync(openSettings, settingsDialogOpen);

  return (
    <OpenSettingsProvider value={openSettings}>
      {children}
      <SettingsDialog
        open={settingsDialogOpen}
        onOpenChange={(val) => {
          setSettingsDialogOpen(val);
          if (!val) setSettingsInitialNavigation({});
        }}
        initialPathname={settingsInitialNavigation.pathname}
      />
    </OpenSettingsProvider>
  );
}
